// extracted by mini-css-extract-plugin
export default {"Container":"Value_Container__Gm2yb","Text":"Value_Text__-ES7h"};